function gatewayBase(): string {
  const configured = (process.env.REACT_APP_API_URL_integration_gateway || '').trim();
  return configured.replace(/\/$/, '') || 'http://127.0.0.1:8001';
}

function errorMessage(err: unknown): string {
  const axiosLike = err as { message?: string };
  return axiosLike.message || 'Login failed';
}

async function postJson(path: string, body: Record<string, string>): Promise<{ redirect: string }> {
  const response = await fetch(`${gatewayBase()}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = (await response.json().catch(() => ({}))) as { redirect?: string; message?: string };
  if (!response.ok || !data.redirect) {
    throw new Error(data.message || 'Login failed');
  }
  return { redirect: data.redirect };
}

export const oauthAuthApi = {
  login(email: string, password: string, oauthTransaction: string) {
    return postJson('/oauth/login', { email, password, oauth_transaction: oauthTransaction }).catch((err) => {
      throw new Error(errorMessage(err));
    });
  },

  complete(token: string, oauthTransaction: string) {
    return postJson('/oauth/complete', { token, oauth_transaction: oauthTransaction }).catch((err) => {
      throw new Error(errorMessage(err));
    });
  },
};
